// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      ui.block = dom(".alert");

      if (!ui.block) {
        return;
      }

      ui.button = dom("button", ui.block);
      ui.button.onclick = this.click;

    },

    /**
     * Method to handle the close button click.
     *
     * @method block.click
     */
    click: function(event) {

      event.preventDefault();

      ui.block.style.display = "none";

      var duration = window.parseFloat(ui.block.dataset.duration);

      // If duration is -1, don't set a cookie at all
      if (duration > -1) {
        // Set the cookie with the specified duration
        utils.setCookie("alert-closed=true", duration);
      }

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
